/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import ImageViewer from './ImageViewer/index'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ImageCard/Content/Content",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
}) {
let imageCardResourceUrlValueData = fromData.useDataValue({ viewPath,
context: 'image_card',
path: 'resource.url',
})
let imageCardLayoutValueData = fromData.useDataFormat({ viewPath,
context: 'image_card',
path: 'layout',
format: fromHelpers.getImagePreviewSize,
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 onClick={onClick}
 width="100%"
 height="100%"
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 objectFit="cover"
 data="image_card.resource.url"
 url={imageCardResourceUrlValueData}
 data="image_card.layout"
 format="helpers.js getImagePreviewSize"
 size={imageCardLayoutValueData}
 opacity={isHoveredManual ? 0.8 : 1}
/>
<Actions
  viewPath={`${viewPath}/Actions`}
 isHovered={isHoveredManual}
/>
</div>
<ImageViewer
  viewPath={`${viewPath}/ImageViewer`}
/>
{children}
</React.Fragment>)
}